import { useState } from "react";
import client from "../api/client";

function PromptDisplay({ category, state, subcategory, prompt, onPromptChange, intentionTags }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const canGenerate = category && state && subcategory;
  // Map session state to session_type
  const getSessionType = (state) => {
    if (!state) return null;
    const s = state.toLowerCase();
    if (s === 'before') return 'before';
    if (s === 'during') return 'during';
    if (s === 'after') return 'after';
    return 'before';
  };

  // Map category to strain_category
  const getStrainCategory = (category) => {
    if (!category) return null;
    const c = category.toLowerCase();
    if (c === 'indica') return 'indica';
    if (c === 'sativa') return 'sativa';
    if (c === 'hybrid') return 'hybrid';
    if (c === 'cbd') return 'cbd';
    return null;
  };

  const handleGenerate = async () => {
    if (!canGenerate) return;
    setLoading(true);
    setError("");

    try {
      const params = {
        session_type: getSessionType(state),
        strain_name: subcategory,
        strain_category: getStrainCategory(category),
      };

      if (intentionTags && intentionTags.length > 0) {
        params.intentions = intentionTags.join(',');
      }

      const res = await client.get("/prompt", { params });
      onPromptChange(res.data.prompt || "");
    } catch (err) {
      setError("Unable to generate prompt.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="PromptDisplay">
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "2px", marginBottom: "8px" }}>
        <span style={{ fontSize: "14px", opacity: 0.8 }}>Prompt:</span>
        <span
          onClick={handleGenerate}
          style={{
            fontSize: "13px",
            color: canGenerate ? "#7dd3e8" : "rgba(255,255,255,0.2)",
            cursor: canGenerate ? "pointer" : "default",
            textDecoration: canGenerate ? "underline" : "none",
            pointerEvents: loading ? "none" : "auto"
          }}
        >
          {loading ? "generating..." : "generate"}
        </span>
      </div>

      {error && <p className="error">{error}</p>}

      <div className="PromptDisplay-body">
        {prompt ? (
          <p style={{ fontStyle: "italic", fontSize: "14px", opacity: 0.8 }}>{prompt}</p>
        ) : (
          <p style={{ fontSize: "13px", opacity: 0.4 }}>
            Select type, state, and strain to generate a prompt.
          </p>
        )}
      </div>
    </div>
  );
}

export default PromptDisplay;